<template>
  <div id="promotion" class="menucontent" v-if="showModal">
    <div class="inmenucontent animate__animated animate__bounceIn" :style="{ backgroundImage: createBackgroundString }">
      <button class="hidemenu" @click="hide">
        <i class="fas fa-times"></i>
      </button>
      <div class="ininmnct px-3">
        <div class="menuhead mb-3">
          <i class="fas fa-code"></i>{{ proData.name }}
        </div>
        <div class="depositimg">
          <h6 class="mb-3">ประเภท : {{ proData.type }}</h6>
        </div>
        <div v-if="state === 1">
          <div class="-coupon-box">
            <img
              :src="proData.picture"
              alt="คูปองเล่นคาสิโนออนไลน์ โบนัสสล็อตออนไลน์"
              class="img-responsive center-block d-block mx-auto"
              style="width: 100%; height: auto"
            />
          </div>
          <div class="animate__animated animate__flipInX">
            <div class="form-group mb-4">
              <hr />
              <div class="text-center" style="font-size: 1.2rem">
                {{ proData.detail }}
              </div>
              <br />

              <a v-if="proData.type_promotion === 'P'">
                <div class="toggle" style="margin: auto">
                  <input
                    type="radio"
                    name="sizeBy"
                    value="1"
                    id="size1"
                    v-model="step"
                  />
                  <label for="size1"
                    >step1 / ฝาก {{ proData.deposit }} รับ
                    {{ proData.credit }} ถอนได้
                    {{ proData.withdraw_max }}</label
                  >
                </div>
                <br />
                <div class="toggle" style="margin: auto">
                  <input
                    type="radio"
                    name="sizeBy"
                    value="2"
                    id="size2"
                    v-model="step"
                  />
                  <label for="size2"
                    >step2 / ฝาก {{ proData.deposit2 }} รับ
                    {{ proData.credit2 }} ถอนได้
                    {{ proData.withdraw_max2 }}</label
                  >
                </div>
                <br />
                <div class="toggle" style="margin: auto">
                  <input
                    type="radio"
                    name="sizeBy"
                    value="3"
                    id="size3"
                    v-model="step"
                  />
                  <label for="size3"
                    >step3 / ฝาก {{ proData.deposit3 }} รับ
                    {{ proData.credit3 }} ถอนได้
                    {{ proData.withdraw_max3 }}</label
                  >
                </div>
                <br />
                <div class="toggle" style="margin: auto">
                  <input
                    type="radio"
                    name="sizeBy"
                    value="4"
                    id="size4"
                    v-model="step"
                  />
                  <label for="size4"
                    >step4 / ฝาก {{ proData.deposit4 }} รับ
                    {{ proData.credit4 }} ถอนได้
                    {{ proData.withdraw_max4 }}</label
                  >
                </div>
              </a>
            </div>
          </div>
        </div>
        <div class="text-center mt-3">
          <b style="color: red; font-size: 18px"
            ><i>กรุณาอ่าน เงื่อนไขการรับโปรโมชั่น !!</i></b
          >
        </div>
        <div class="text-left mt-3" style="font-size: 13px">
          1.ยอดเงินในกระเป๋าจะถูกหักตามโปรโมชั่น<br />
          2.หลังจากรับโปรโมชั่น ยอดเงินในกระเป๋า =
          ยอดคงเหลือหลังจากหักค่าโปรโมชั่น + ยอดโบนัสของโปรโมชั่น
          ยอดทั้งหมดจะติดเทิร์น<br />
          3.จะไม่สามารถยกเลิก หรือ ทำการถอนได้
          จนกว่าจะทำโปรโมชั่นผ่านกติกาหรือยอดเงินในกระเป๋าหมดและฝากมาใหม่<br />
          4.ห้ามซื้อฟีเจอร์ หรือ ซ่อนฟีเจอร์ทุกชนิด<br />
          5.ขอสงวนสิทธิ์ในการยกเลิกรายการถอนทุกกรณีที่ทำผิดกติกา<br />
          <div class="text-center mt-3">
            <input
              type="checkbox"
              class="form-check-input"
              id="term_check"
              v-model="term_check"
              style="cursor: pointer"
            />ข้าพเจ้าได้อ่านและทำความเข้าใจเรียบร้อย
          </div>
        </div>

        <div class="text-center mt-3">
          <button
            type="submit"
            class="button button2"
            @click="onSubmit"
            :disabled="
              !term_check ||
              this.step == ''
            "
            v-if="proData.type_promotion === 'P'"
          >
            <i class="far fa-check">&nbsp;ยืนยัน</i></button>
          <button
            type="submit"
            class="button button2"
            @click="onSubmit"
            :disabled="
              !term_check
            "
            v-else
          >
            <i class="far fa-check">&nbsp;ยืนยัน</i></button
          >&nbsp;<button type="submit" class="button button3" @click="hide">
            <i class="far fa-times">&nbsp;ยกเลิก</i></button
          ><br />
        </div>
      </div>
    </div>
    <div class="overlaymenu"></div>
  </div>
</template>

<script>
import { HTTP } from "@/services/http-common";
import { mapGetters } from "vuex";

export default {
  name: "promotionmodal-component",
  data() {
    return {
      showModal: false,
      type_promotion: "",
      state: 1,
      queryId: "",
      step: "",
      proData: [],
      promotionModal: false,
      isLoading: false,
      fullPage: false,
      loader: "bars",
      term_check: false,
    };
  },
  methods: {
    onSubmit() {
      this.isLoading = true;
      HTTP.post(`member/promotion`, {
        id: this.queryId,
        step: this.step,
      })
        .then((resp) => {
          // document.getElementById("regis").disabled = true;
          if (resp.data.status != undefined && !resp.data.status) {
            this.$toast.error(
              resp.data.msg != undefined
                ? resp.data.msg
                : "ไม่สามารถทำรายการได้ กรุณาลองใหม่"
            );
            // document.getElementById("regis").disabled = false;
          } else {
            this.$toast.success(
              resp.data.msg != undefined ? resp.data.msg : "รับโปรโมชั่นสำเร็จ"
            );
            // document.getElementById("regis").disabled = true;
            this.hide();
            this.fetchUserProfile();
          }
        })
        .catch((err) => {
          this.$toast.error(
            err.data.msg != undefined
              ? err.data.msg
              : "ไม่สามารถทำรายการได้ กรุณาลองใหม่"
          );
        })
        .then(() => {
          this.isLoading = false;
        });
    },
    fetchPromotion() {
      HTTP.get(`system/promotion?id=` + this.queryId)
        .then((resp) => {
          if (resp.data.status != undefined && !resp.data.status) {
            this.$toast.error(
              resp.data.msg != undefined
                ? resp.data.msg
                : "ไม่สามารถโหลดข้อมูลได้ กรุณาลองใหม่"
            );
          } else {
            this.proData = resp.data.data;
            this.promotionModal = true;
            // console.log(this.proData.type_promotion);
          }
        })
        .catch((err) => {
          if (err.response) {
            this.$toast.error(
              err.response.data.msg != undefined
                ? err.response.data.msg
                : "ไม่สามารถโหลดข้อมูลได้ กรุณาลองใหม่"
            );
          }
        });
    },
    fetchUserProfile() {
      HTTP.get(`member/profile`, {})
        .then((resp) => {
          if (resp.data.status != undefined && !resp.data.status) {
            this.$toast.error(
              resp.data.msg != undefined
                ? resp.data.msg
                : "ไม่สามารถโหลดข้อมูลโปรไฟล์ได้ กรุณาลองใหม่"
            );
          } else {
            if (resp.data.status != undefined && resp.data.status) {
              this.$store.dispatch("saveProfile", resp.data.data);
            }
          }
        })
        .catch((err) => {
          if (err.response) {
            if (err.response.status === 401) {
              this.$store.dispatch("logoutAuth");
            } else {
              this.$toast.error(
                err.response.data.msg != undefined
                  ? err.response.data.msg
                  : "ไม่สามารถโหลดข้อมูลโปรไฟล์ได้ กรุณาลองใหม่"
              );
            }
          }
        });
    },
    show(id) {
      this.showModal = true;
      this.state = 1;
      this.queryId = id;
      this.fetchPromotion();
    },
    hide() {
      (this.state = 1), (this.proData = []);
      this.promotionModal = false;
      this.showModal = false;
    },
  },computed: {
    ...mapGetters(["WebSetting"]),
    createBackgroundString() {
      return `linear-gradient(140deg, ${this.WebSetting.color1}, #000000 95%), linear-gradient(180deg, #a78059 -30%, #f2d7a9 22%, #715236 72%, #f1bb73 112%)`;
    },
  }
};
</script>

<style>
.button {
  border-radius: 5px;
  color: white;
  padding: 16px 32px;
  text-align: center;
  text-decoration: none;
  display: inline-block;
  font-size: 16px;
  margin: 4px 2px;
  transition-duration: 0.4s;
  cursor: pointer;
}
.button2 {
  background-color: #1d7e00;
  color: rgb(0, 0, 0);
}

.button2:hover {
  background-color: #72fd00;
  color: white;
}
.button3 {
  background-color: #800000;
  color: rgb(0, 0, 0);
}

.button3:hover {
  background-color: #ff1717;
  color: white;
}
.button2:disabled {
  border-radius: 5px;
  color: white;
  padding: 16px 32px;
  text-align: center;
  text-decoration: none;
  display: inline-block;
  font-size: 16px;
  margin: 4px 2px;
  transition-duration: 0.4s;
  cursor: pointer;
}
button:disabled,
button[disabled] {
  padding: 10px;
  border: none;
  border-radius: 10px;
  /* width: 100%; */
  margin-top: 20px;
  background: #327834;
}
</style>
